<!-- UI desktop -->
<div class="contains-main" *ngIf="!isViewAll">
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
        <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]="objectChoosing.id_block? objectChoosing.id_block: objectChoosing.id_object"></app-position-out-config>

        <app-width-height-config   [device]="device"   [elementChoosing]="objectChoosing" [width]="class['search-box']['width']" [height]="class['search-box']['height']"
        (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
        <!-- Ẩn hiện chức năng -->
        <li nz-submenu nzTitle="{{'an_hien_chuc_nang' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
            <div class="ml-2">
                <div class="switch-image">
                    <p class="title">{{'an_nut_tim_kiem' | translate}}</p>
                    <nz-switch 
                    [(ngModel)]="config['format_button']['hide_button_search']"
                    (ngModelChange)="updateConfig()"></nz-switch>
                </div>
                <div class="switch-image">
                    <p class="title">{{'an_ket_qua_tim_kiem' | translate}}</p>
                    <nz-switch 
                        [(ngModel)]="config['format_search_result']['hide_data_enabled']" 
                        (ngModelChange)="updateConfig()"></nz-switch>
                </div>
                <ng-container *ngIf="config['format_search_result']['hide_data_enabled']">
                    <p class="config-message">
                        {{'config_message' | translate}}
                    </p>

                </ng-container>
            </div>
        </li>
        <!-- Cấu hình thanh tìm kiếm -->
        <li nz-submenu nzTitle="{{'cau_hinh_thanh_tim_kiem' | translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
            <ul class="ml-2" nz-menu nzMode="inline">
                <!-- Bật đổ bóng -->
                <li nz-submenu nzTitle="{{'do_bong_thanh_tim_kiem' | translate}}">
                    <app-shadow-config 
                        [device]="device"
                        [config]="config"
                        [class]="class"
                        [shadowClass]="class['search-box']"
                        [shadowConfig]="config['search_box_shadow']"
                        [objectChoosing]="objectChoosing"
                        >
                    </app-shadow-config>
                </li>
                <!-- Cấu hình viền thanh tìm kiếm -->
                <li nz-submenu nzTitle="{{'vien_thanh_tim_kiem' | translate}}">
                    <div class="main-config">
                        <app-borders-config 
                            [device]="device"
                            [elementChoosing]="objectChoosing"
                            [class]="class"
                            [borderClass]="class['search-box']"
                            [id_object]="objectChoosing._id"
                        >
                        </app-borders-config>
                        
                        <!-- Nút mở rộng -->
                        <div class="config-name view-more-btn">
                            <p (click)="openViewAll(stylefields[7])">{{'mo_rong' | translate}} &#8594;</p>
                        </div>
                    </div>
                </li>
            </ul>
        </li>
        <!-- Cấu hình ô tìm kiếm -->
        <li nz-submenu nzTitle="{{'cau_hinh_o_tim_kiem' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
            <ul class="ml-2" nz-menu nzMode="inline">
                <!-- Định dạng chữ gợi ý -->
                <li nz-submenu nzTitle="{{'dinh_dang_chu_goi_y' | translate}}">
                    <div class="container-font">
                        <div class="config-text" style="width: 100%">
                            <mat-form-field style="width: 100%">
                                <mat-label>{{'noi_dung_chu_goi_y' | translate}}</mat-label>
                                <textarea style="padding-top: 7px" matInput 
                                    [ngModel]="staticdata['input_text_placeholder_' + functionService.selectedLanguageCode] | vhLanguage : 'input_text_placeholder' : objectChoosing.component" 
                                    (ngModelChange)="staticdata['input_text_placeholder_' + functionService.selectedLanguageCode] = $event" 
                                    (blur)="updateStaticData()" ></textarea>
                            </mat-form-field>
                        </div>

                        <app-text-format-config
                            [device]="device"
                            [objectChoosing]="objectChoosing"
                            [class]="class"
                            [config]="config"
                            [fonts]="fontsListItem"
                            [staticdata]="staticdata"
                            [textContentClass]="class['search-box__input-placeholder']"
                            [textWrapperClass]="class['search-box__input-placeholder']"
                            >
                        </app-text-format-config>
                    </div>
                </li>
                <!-- Định dạng chữ khi nhập -->
                <li nz-submenu nzTitle="{{'dinh_dang_chu_khi_nhap' | translate}}">
                    <app-text-format-config
                            [device]="device"
                            [objectChoosing]="objectChoosing"
                            [class]="class"
                            [config]="config"
                            [fonts]="fontsListItem"
                            [staticdata]="staticdata"
                            [textContentClass]="class['search-box__input']"
                            [textWrapperClass]="class['search-box__input']"
                            >
                    </app-text-format-config>
                </li>
                <!-- Định dạng ô -->
                <li nz-submenu nzTitle="{{'dinh_dang_o' | translate}}">
                    <ul nz-menu nzMode="inline">
                        <li nz-submenu nzTitle="{{'tuy_chinh_kieu_vien_tim_kiem' | translate}}">
                            <div class="main-config">
                                <app-borders-config [device]="device"
                                                    [elementChoosing]="objectChoosing"
                                                    [class]="class"
                                                    [borderClass]="class['search-box__input']"
                                                    [id_object]="objectChoosing._id"
                                >
                                </app-borders-config>
                                
                                <!-- Nút mở rộng -->
                                <div class="config-name view-more-btn">
                                    <p (click)="openViewAll(stylefields[0])">{{'mo_rong' | translate}} &#8594;</p>
                                </div>
                            </div>
                        </li>
                        <!-- Khoảng cách với nút tìm kiếm -->
                        <li nz-submenu nzTitle="{{'khoang_cach_voi_nut_tim_kiem' | translate}}">
                            <div style="padding-left: 5px;">
                                <div class="config-name mb-0">
                                    <p>{{'khoang_cach' | translate}}</p>
                                    <nz-input-number [nzMin]="0" [nzMax]="200" [nzStep]="1"
                                      [ngModel]="class['search-box']['gap'] | vhnumber"
                                      (ngModelChange)="class['search-box']['gap'] = $event + 'px'"
                                      (nzBlur)="updateClass()">
                                    </nz-input-number>
                                </div>
                                <nz-slider [nzMin]="0" [nzMax]="200" [nzStep]="1"
                                  [ngModel]="class['search-box']['gap'] | vhnumber"
                                  (ngModelChange)="class['search-box']['gap'] = $event + 'px'"
                                  (nzOnAfterChange)="updateClass()">
                                </nz-slider>
                            </div>
                        </li>
                        <!-- Khoảng đệm -->
                        <li nz-submenu [nzTitle]="'khoang_dem' | translate">
                            <div class="px-2">
                                <app-padding-config
                                    [objectChoosing]="objectChoosing"
                                    [device]="device"
                                    [class]="class"
                                    [classPadding]="class['search-box__input']"
                                    [paddingConfigs]="[
                                        { type: 'top' },
                                        { type: 'bottom' },
                                        { type: 'left' },
                                        { type: 'right' }
                                    ]">
                                </app-padding-config>
                            </div>
                        </li>
                    </ul>
                </li>
                <li nz-submenu nzTitle="{{'chon_mau_nen_o_tim_kiem' | translate}}">
                    <div class="container-color">
                        <button id="btn-color" *ngFor="let background of backgroundColor; let i = index"
                          [ngStyle]="{ 'background-color': background.bgColor }" (click)="chooseBg(background, $event, 'input')" nz-tooltip
                          [disabled]="config['background-color-input'].gradient_check"></button>
                    </div>
                    <div class="config-name" style="padding-left: 5px;">
                        <p>{{'mau_nen_o_tim_kiem' | translate}}</p>
                        <input class="input-color" type="button"
                            [style.background]="config['background-color-input'].gradient_check ? '#9e9e9e' : class['search-box__input']['background']"
                            [cpOKButton]="true" [(colorPicker)]="class['search-box__input']['background']"
                            (colorPickerClose)="updateClass()" 
                            [disabled]="config['background-color-input'].gradient_check"/>
                    </div>
                    <div class="config-name view-more-btn">
                        <p (click)="openViewAll(stylefields[3])">{{'mo_rong' | translate}} &#8594;</p>
                    </div>
                </li>
                <!-- Nhãn ô -->
                <li nz-submenu nzTitle="{{'nhan_o' | translate}}">
                    <mat-form-field style="width: 100%" class="aria-label-input" [matTooltip]="'*_giai_thich_aria_label' | translate">
                        <mat-label>{{'nhan_o' | translate}}<span style="color: red">*</span></mat-label>
                        <textarea matInput
                        [ngModel]="staticdata.accessibility?.['aria_label_input_' + functionService.selectedLanguageCode]"
                        (ngModelChange)="staticdata.accessibility['aria_label_input_' + functionService.selectedLanguageCode] = $event"
                        (blur)="updateStaticData();"></textarea>
                    </mat-form-field>
                </li>
            </ul>
        </li>
        <!-- Cấu hình nút tìm kiếm -->
        <li nz-submenu nzTitle="{{'cau_hinh_nut_tim_kiem' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
            <!-- Vị trí nút -->
            <!-- <div class="switch-image twins">
                <mat-form-field style="width: 100%;">
                    <mat-label>Chọn vị trí</mat-label>
                    <mat-select [(ngModel)]="objectChoosing[device+'_format_button'].position_button" (ngModelChange)="updateCss(device+'_format_button', objectChoosing[device+'_format_button']);">
                        <mat-option *ngFor="let options of positionOptions" [value]="options.value">{{options.label}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div> -->
            <ul class="ml-2" nz-menu nzMode="inline">
                <!-- Cấu hình format font name của button -->
                <li nz-submenu nzTitle="{{'dinh_dang_ten_nut' | translate}}">
                    <div class="item-symbol">
                        <p class="title" style="line-height: 1.5">{{'an_bieu_tuong_van_ban' | translate}}</p>
                        <nz-switch [(ngModel)]="config['format_button_text']['hide_button_search']" (ngModelChange)="updateConfig()"></nz-switch>
                    </div>
                    <!-- <div class="d-flex justify-content-between mx-1">
                        <mat-icon>{{ config["format_button_text"]['name'] }}</mat-icon>
                        <button nz-button nzType="default" (click)="openDialogChooseIcon()" style="border-radius: 5px"
                            [disabled]="config['format_button_text']['hide_button_search']">
                            Thay đổi
                        </button>
                    </div> -->
                    <div *ngIf="!config['format_button_text']['hide_button_search']">
                        <div class="container-font">
                            <div class="config-text" style="width: 100%">
                                <mat-form-field style="width: 100%">
                                    <mat-label>{{'tieu_de_nut' | translate}}</mat-label>
                                    <textarea style="padding-top: 7px" matInput
                                        [ngModel]="config['format_button_text']['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component" 
                                        (ngModelChange)="config['format_button_text']['content_' + functionService.selectedLanguageCode] = $event" 
                                        (blur)="updateConfig()"></textarea>
                                </mat-form-field>
                            </div>
                            <div class="config-font-size">
                                <div class="field-row-font" style="width: 65%">
                                    <mat-form-field style="width: 100%">
                                        <mat-label>Font</mat-label>
                                        <mat-select [(ngModel)]="
                                            class['search-box__button-text']['font-family']
                                            " (ngModelChange)="updateClass()" [(value)]="class['search-box__button-text']['font-family']">
                                        <mat-option *ngFor="let font of fontsListItem" [value]="font.value">{{
                                            font.name
                                            }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="field-row-size" style="width: 35%">
                                    <mat-form-field style="width: 100%">
                                        <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                                        <input matInput type="number" [ngModel]="
                                            class['search-box__button-text']['font-size'] | vhnumber
                                            " (ngModelChange)="
                                            class['search-box__button-text']['font-size'] =
                                                $event + 'px'
                                            " />
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="config-font">
                                <p class="title-font">{{'kieu_chu' | translate}}</p>
                                <div class="field-row">
                                    <div style="display:flex; width: 80%">
                                        <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                                            class['search-box__button-text']['font-weight'] == 'bold' ? 'primary' : 'default'" 
                                            (click)="
                                            class['search-box__button-text']['font-weight'] =
                                            class['search-box__button-text']['font-weight'] == 'bold' ? '500' : 'bold';updateClass()">
                                            <span style="font-weight: 600">B</span>
                                        </button>
                                        <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                                                class['search-box__button-text']['font-style'] == 'italic'
                                                ? 'primary'
                                                : 'default'
                                            " (click)="
                                                class['search-box__button-text']['font-style'] =
                                                class['search-box__button-text']['font-style'] == 'normal'
                                                    ? 'italic'
                                                    : 'normal';
                                                updateClass()
                                            ">
                                            <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                                                class['search-box__button-text']['text-decoration'] ==
                                                'underline'
                                                ? 'primary'
                                                : 'default'
                                            " (click)="
                                                class['search-box__button-text']['text-decoration'] =
                                                class['search-box__button-text']['text-decoration'] ==
                                                'none'
                                                    ? 'underline'
                                                    : 'none';
                                                updateClass()
                                            ">
                                            <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                                                class['search-box__button-text']['text-transform'] ==
                                                'uppercase'
                                                ? 'primary'
                                                : 'default'
                                            " (click)="
                                                class['search-box__button-text']['text-transform'] =
                                                class['search-box__button-text']['text-transform'] ==
                                                'none'
                                                    ? 'uppercase'
                                                    : 'none';
                                                updateClass()
                                            ">
                                            <span>AB</span>
                                        </button>
                                    </div>
                                    
                                    <div style="width: 15%;">
                                        <input id="color" type="button"
                                        [cpOKButton]="true" [(colorPicker)]="class['search-box__button-text']['color']"
                                        [style.background]="class['search-box__button-text']['color']" (colorPickerClose)="updateObject()"/>
                                    </div>
                                </div>
                            </div>
                            <div class="font-adjusting">
                                <div class="row-spacing">
                                    <span class="title">{{'gian_cach_chu' | translate}}</span>
                                    <nz-input-number [nzMin]="0" [nzMax]="30" [ngStyle]="{ width: '40%' }" [ngModel]="
                                            class['search-box__button-text']['letter-spacing'] | vhnumber
                                        " (nzBlur)="updateClass()" (ngModelChange)="
                                            class['search-box__button-text']['letter-spacing'] =
                                            $event + 'px'
                                        "></nz-input-number>
                                </div>
                                <nz-slider [nzMin]="0" [nzMax]="30" [ngModel]="
                                        class['search-box__button-text']['letter-spacing'] | vhnumber
                                        " (nzOnAfterChange)="updateClass()" (ngModelChange)="
                                        class['search-box__button-text']['letter-spacing'] =
                                            $event + 'px'
                                        "></nz-slider>
                            </div>
                        </div>
                    </div>
                    
                </li>
                <!-- Cấu hình biểu tượng -->
                <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}">
                    <app-symbol-config
                        [device]="device"
                        [class]="class"
                        [config]="config"
                        [symbolClass]="class['search-box__button']"
                        [fontSizeIconClass]="class['search-box__button-icon']"
                        [symbolConfig]="config['format_icon_search']"
                        [objectChoosing]="objectChoosing">
                    </app-symbol-config>
                </li>
                <!-- chọn màu nền button -->
                <li nz-submenu nzTitle="{{'chon_mau_nen_nut' | translate}}">
                    <div class="container-color">
                        <button id="btn-color" *ngFor="let background of backgroundColor; let i = index"
                          [ngStyle]="{ 'background-color': background.bgColor }" (click)="chooseBg(background, $event, 'button')" nz-tooltip
                          [disabled]="config['background-color-button'].gradient_check"></button>
                    </div>
                    <div class="config-name" style="padding-left: 5px;">
                        <p>{{'mau_nen_nut' | translate}}</p>
                        <input class="input-color" type="button"
                            [style.background]="config['background-color-button'].gradient_check ? '#9e9e9e' : class['search-box__button']['background']"
                            [cpOKButton]="true" [(colorPicker)]="class['search-box__button']['background']"
                            (colorPickerClose)="updateClass()" 
                            [disabled]="config['background-color-button'].gradient_check"/>
                    </div>
                    <!-- Nút mở rộng -->
                    <div class="config-name view-more-btn">
                        <p (click)="openViewAll(stylefields[6])">{{'mo_rong' | translate}} &#8594;</p>
                    </div>
                    <!-- Mở popup so sánh màu tương phản -->
                    <button *ngIf="!config['format_button']['hide_button_search'] && !config['format_button_text']['hide_button_search']"
                    nz-row (click)="openColorContrast()" nz-tooltip
                    [nzTooltipTitle]="'dung_de_toi_uu_chi_so_accessibility_kha_nang_tiep_can_tren_pagespeed' | translate"
                    style="color: #fff; background-color: #00a859; width: 100%; padding: 8px; border-radius: 8px;">
                        {{ 'so_sanh_do_tuong_phan_giua_mau_chu_icon_va_mau_nen' | translate }}
                    </button>
                </li>
                <!-- "Chỉnh kích thước nút -->
                <li nz-submenu nzTitle="{{'chinh_kich_thuoc_nut' | translate}}">
                    <div style="padding-left: 5px;">
                        <div class="config-name mb-0">
                            <p>{{'kich_thuoc_nut' | translate}}</p>
                            <nz-input-number [nzMin]="1" [nzMax]="200" [nzStep]="1"
                              [ngModel]="class['search-box__button']['width'] | vhnumber"
                              (ngModelChange)="class['search-box__button']['width'] = $event + 'px'"
                              (nzBlur)="updateClass()">
                            </nz-input-number>
                        </div>
                        <nz-slider [nzMin]="1" [nzMax]="200" [nzStep]="1"
                          [ngModel]="class['search-box__button']['width'] | vhnumber"
                          (ngModelChange)="class['search-box__button']['width'] = $event + 'px'"
                          (nzOnAfterChange)="updateClass()">
                        </nz-slider>
                    </div>
                </li>
                <!-- tùy chỉnh viền button-->
                <li nz-submenu nzTitle="{{'kieu_vien_nut' | translate}}">
                    <div style="padding-left: 5px;">
                        <app-borders-config [device]="device"
                        [elementChoosing]="objectChoosing"
                        [class]="class"
                        [borderClass]="class['search-box__button']"
                        [id_object]="objectChoosing._id"
                        >
                        </app-borders-config>
                        <!-- Nút mở rộng -->
                        <div class="config-name view-more-btn">
                            <p (click)="openViewAll(stylefields[1])">{{'mo_rong' | translate}} &#8594;</p>
                        </div>
                    </div>
                </li>
                <!-- Nhãn nút -->
                <li nz-submenu nzTitle="{{'nhan_nut' | translate}}">
                    <mat-form-field style="width: 100%" class="aria-label-input" [matTooltip]="'*_giai_thich_aria_label' | translate">
                        <mat-label>{{'nhan_nut' | translate}}<span style="color: red">*</span></mat-label>
                        <textarea matInput
                        [ngModel]="staticdata.accessibility?.['aria_label_btn_' + functionService.selectedLanguageCode]"
                        (ngModelChange)="staticdata.accessibility['aria_label_btn_' + functionService.selectedLanguageCode] = $event"
                        (blur)="updateStaticData();"></textarea>
                    </mat-form-field>
                </li>
            </ul>
        </li>
        <!-- Cấu hình kết quả tìm kiếm -->
        <li *ngIf="!config['format_search_result']['hide_data_enabled']" 
            nz-submenu nzTitle="{{'cau_hinh_ket_qua_tim_kiem' | translate}}" 
            [(nzOpen)]="openMap.menu5" 
            (nzOpenChange)="openHandler('menu5')" (mouseover)="showResult()" (mouseleave)="hideResult()">
            <div class="ml-2">
                <div class="config-name">
                    <p class="title">{{'an_hinh_anh' | translate}} {{mainSectorTranslate[staticdata.main_sector] || 'san_pham' | translate}}</p>
                    <nz-switch [(ngModel)]="config['format_search_result']['hide_image_enabled']" 
                               (ngModelChange)="updateConfig()"></nz-switch>
                </div>
                <!-- {{'an_gia_ban' | translate}} -->
                <div *ngIf="!hidePriceMainSector.includes(staticdata.main_sector)" class="config-name">
                    <p class="title">{{'an_gia_ban' | translate}}</p>
                    <nz-switch [(ngModel)]="config['format_search_result']['hide_price_enabled']" 
                               (ngModelChange)="updateConfig()"></nz-switch>
                </div>
                <!-- Cấu hình giá bán -->
                <div *ngIf="!config['format_search_result']['hide_price_enabled'] && !hidePriceMainSector.includes(staticdata.main_sector)" >
                    <div class="config-font-size">
                        <div class="field-row-font" style="width: 65%">
                            <mat-form-field style="width: 100%">
                                <mat-label>{{'font_gia_ban' | translate}}</mat-label>
                                <mat-select [(ngModel)]="
                                    class['search-result__price']['font-family']
                                    " (ngModelChange)="updateClass()" [(value)]="class['search-result__price']['font-family']">
                                <mat-option *ngFor="let font of fontsListItem" [value]="font.value">{{
                                    font.name
                                    }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="field-row-size" style="width: 35%">
                            <mat-form-field style="width: 100%">
                                <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                                <input matInput type="number" [ngModel]="
                                    class['search-result__price']['font-size'] | vhnumber
                                    " (ngModelChange)="
                                    class['search-result__price']['font-size'] =
                                        $event + 'px';
                                        updateClass()
                                    " />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="config-font">
                        <p class="title-font">{{'kieu_chu_gia_ban' | translate}}</p>
                        <div class="field-row">
                            <div style="display:flex; width: 80%">
                                <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                                class['search-result__price']['font-weight'] == 'bold' ? 'primary' : 'default'" 
                                (click)="
                                class['search-result__price']['font-weight'] =
                                class['search-result__price']['font-weight'] == 'bold' ? '500' : 'bold';
                                updateClass()">
                                    <span style="font-weight: 600">B</span>
                                </button>
                                <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                                        class['search-result__price']['font-style'] == 'italic'
                                        ? 'primary'
                                        : 'default'
                                    " (click)="
                                        class['search-result__price']['font-style'] =
                                        class['search-result__price']['font-style'] == 'normal'
                                            ? 'italic'
                                            : 'normal';
                                        updateClass()
                                    ">
                                    <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                                </button>
                                <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                                        class['search-result__price']['text-decoration'] ==
                                        'underline'
                                        ? 'primary'
                                        : 'default'
                                    " (click)="
                                        class['search-result__price']['text-decoration'] =
                                        class['search-result__price']['text-decoration'] ==
                                        'none'
                                            ? 'underline'
                                            : 'none';
                                        updateClass()
                                    ">
                                    <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                                </button>
                                <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                                        class['search-result__price']['text-transform'] ==
                                        'uppercase'
                                        ? 'primary'
                                        : 'default'
                                    " (click)="
                                        class['search-result__price']['text-transform'] =
                                        class['search-result__price']['text-transform'] ==
                                        'none'
                                            ? 'uppercase'
                                            : 'none';
                                        updateClass()
                                    ">
                                    <span>AB</span>
                                </button>
                            </div>
                            
                            <div style="width: 15%">
                                <input id="color" type="button"
                                [cpOKButton]="true" [(colorPicker)]="class['search-result__price']['color']"
                                [style.background]="class['search-result__price']['color']"
                                (colorPickerClose)="updateObject()"/>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- {{'an_gia_ban' | translate}} trước khi khuyến mãi -->
                <div *ngIf="!hidePriceMainSector.includes(staticdata.main_sector)" class="config-name">
                    <p class="title">{{'an_gia_ban' | translate}} {{'truoc_khi_khuyen_mai' | translate}}</p>
                    <nz-switch [(ngModel)]="config['format_search_result']['hide_price_sales_enabled']" 
                               (ngModelChange)="updateConfig()"></nz-switch>
                </div>
                <!-- Cấu hình giá bán trước khi khuyến mãi -->
                <div *ngIf="!config['format_search_result']['hide_price_sales_enabled'] && !hidePriceMainSector.includes(staticdata.main_sector)">
                    <div class="config-font-size">
                        <div class="field-row-font" style="width: 65%">
                            <mat-form-field style="width: 100%">
                                <mat-label>{{'font_gia_truoc_khuyen_mai' | translate}}</mat-label>
                                <mat-select [(ngModel)]="
                                    class['search-result__price-sales']['font-family']
                                    " (ngModelChange)="updateClass()" [(value)]="class['search-result__price-sales']['font-family']">
                                <mat-option *ngFor="let font of fontsListItem" [value]="font.value">{{
                                    font.name
                                    }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="field-row-size" style="width: 35%">
                            <mat-form-field style="width: 100%">
                                <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                                <input matInput type="number" [ngModel]="
                                    class['search-result__price-sales']['font-size'] | vhnumber
                                    " (ngModelChange)="
                                    class['search-result__price-sales']['font-size'] =
                                        $event + 'px';
                                        updateClass()
                                    " />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="config-font">
                        <p class="title-font">{{'kieu_chu_gia_truoc_khuyen_mai' | translate}}</p>
                        <div class="field-row">
                            <div style="display:flex; width: 80%">
                                <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                                class['search-result__price-sales']['font-weight'] == 'bold' ? 'primary' : 'default'" 
                                (click)="
                                class['search-result__price-sales']['font-weight'] =
                                class['search-result__price-sales']['font-weight'] == 'bold' ? '500' : 'bold';
                                updateClass()">
                                    <span style="font-weight: 600">B</span>
                                </button>
                                <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                                        class['search-result__price-sales']['font-style'] == 'italic'
                                        ? 'primary'
                                        : 'default'
                                    " (click)="
                                        class['search-result__price-sales']['font-style'] =
                                        class['search-result__price-sales']['font-style'] == 'normal'
                                            ? 'italic'
                                            : 'normal';
                                        updateClass()
                                    ">
                                    <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                                </button>
                                <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                                        class['search-result__price-sales']['text-decoration'] ==
                                        'underline'
                                        ? 'primary'
                                        : 'default'
                                    " (click)="
                                        class['search-result__price-sales']['text-decoration'] =
                                        class['search-result__price-sales']['text-decoration'] ==
                                        'none'
                                            ? 'underline'
                                            : 'none';
                                        updateClass()
                                    ">
                                    <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                                </button>
                                <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                                        class['search-result__price-sales']['text-transform'] ==
                                        'uppercase'
                                        ? 'primary'
                                        : 'default'
                                    " (click)="
                                        class['search-result__price-sales']['text-transform'] =
                                        class['search-result__price-sales']['text-transform'] ==
                                        'none'
                                            ? 'uppercase'
                                            : 'none';
                                        updateClass()
                                    ">
                                    <span>AB</span>
                                </button>
                            </div>
                            
                            <div style="width: 15%">
                                <input id="color" type="button"
                                [cpOKButton]="true" [(colorPicker)]="class['search-result__price-sales']['color']"
                                [style.background]="class['search-result__price-sales']['color']"
                                (colorPickerClose)="updateObject()"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="config-name mb-0">
                        <p class="title">{{'so_luong_ket_qua_hien_thi' | translate}} </p>
                        <nz-input-number [nzMin]="1" [nzMax]="10" [nzStep]="1"
                          [ngModel]="config['format_search_result']['max_number_search_result'] | vhnumber"
                          (ngModelChange)="config['format_search_result']['max_number_search_result'] = $event"
                          (nzOnAfterChange)="updateConfig()">
                        </nz-input-number>
                    </div>
                    <nz-slider [nzMin]="1" [nzMax]="10" [nzStep]="1"
                      [ngModel]="config['format_search_result']['max_number_search_result'] | vhnumber"
                      (ngModelChange)="config['format_search_result']['max_number_search_result'] = $event"
                      (nzOnAfterChange)="updateConfig()">
                    </nz-slider>
                </div>

                <div class="config-font-size">
                    <div class="field-row-font" style="width: 65%">
                        <mat-form-field style="width: 100%">
                            <mat-label>{{'font_ten_san_pham' | translate}}</mat-label>
                            <mat-select [(ngModel)]="
                                class['search-result__name']['font-family']
                                " (ngModelChange)="updateClass()" [(value)]="class['search-result__name']['font-family']">
                            <mat-option *ngFor="let font of fontsListItem" [value]="font.value">{{
                                font.name
                                }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="field-row-size" style="width: 35%">
                        <mat-form-field style="width: 100%">
                            <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                            <input matInput type="number" [ngModel]="
                                class['search-result__name']['font-size'] | vhnumber
                                " (ngModelChange)="
                                class['search-result__name']['font-size'] =
                                    $event + 'px';
                                    updateClass()
                                " />
                        </mat-form-field>
                    </div>
                </div>
                <div class="config-font">
                    <p class="title-font">{{'kieu_chu_san_pham' | translate}}</p>
                    <div class="field-row">
                        <div style="display:flex; width: 80%">
                            <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                            class['search-result__name']['font-weight'] == 'bold' ? 'primary' : 'default'" 
                            (click)="
                            class['search-result__name']['font-weight'] =
                            class['search-result__name']['font-weight'] == 'bold' ? '500' : 'bold';
                            updateClass()">
                                <span style="font-weight: 600">B</span>
                            </button>
                            <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                                    class['search-result__name']['font-style'] == 'italic'
                                    ? 'primary'
                                    : 'default'
                                " (click)="
                                    class['search-result__name']['font-style'] =
                                    class['search-result__name']['font-style'] == 'normal'
                                        ? 'italic'
                                        : 'normal';
                                    updateClass()
                                ">
                                <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                            </button>
                            <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                                    class['search-result__name']['text-decoration'] ==
                                    'underline'
                                    ? 'primary'
                                    : 'default'
                                " (click)="
                                    class['search-result__name']['text-decoration'] =
                                    class['search-result__name']['text-decoration'] ==
                                    'none'
                                        ? 'underline'
                                        : 'none';
                                    updateClass()
                                ">
                                <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                            </button>
                            <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                                    class['search-result__name']['text-transform'] ==
                                    'uppercase'
                                    ? 'primary'
                                    : 'default'
                                " (click)="
                                    class['search-result__name']['text-transform'] =
                                    class['search-result__name']['text-transform'] ==
                                    'none'
                                        ? 'uppercase'
                                        : 'none';
                                    updateClass()
                                ">
                                <span>AB</span>
                            </button>
                        </div>
                        
                        <div style="width: 15%">
                            <input id="color" type="button"
                            [cpOKButton]="true" [(colorPicker)]="class['search-result__name']['color']"
                            [style.background]="class['search-result__name']['color']"
                            (colorPickerClose)="updateObject()"/>
                        </div>
                    </div>
                </div>
                <div class="config-name">
                    <p>{{'mau_nen_khung_ket_qua' | translate}}</p>
                    <input class="input-color" type="button"
                        [style.background]="class['search-result']['background-color']"
                        [cpOKButton]="true" [(colorPicker)]="class['search-result']['background-color']"
                        (colorPickerClose)="updateClass()" />
                </div>
                <div class="config-name">
                    <p>{{'mau_nen_o_ket_qua' | translate}}</p>
                    <input class="input-color" type="button"
                        [style.background]="class['search-result__item--border']['background-color']"
                        [cpOKButton]="true" [(colorPicker)]="class['search-result__item--border']['background-color']"
                        (colorPickerClose)="updateClass()" />
                </div>
                <div class="config-name">
                    <p>{{'khoang_cach_giua_cac_san_pham' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="20" [nzStep]="1"
                                [ngModel]="class['search-result__item--border']['margin-bottom'] | vhnumber"
                                (ngModelChange)="class['search-result__item--border']['margin-bottom'] = $event + 'px'"
                                (nzOnAfterChange)="updateClass()"
                            ></nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [nzMax]="20" [nzStep]="1"
                        [ngModel]="class['search-result__item--border']['margin-bottom'] | vhnumber"
                        (ngModelChange)="class['search-result__item--border']['margin-bottom'] = $event + 'px'"
                        (nzOnAfterChange)="updateClass()"></nz-slider>
                <div class="config-name">
                    <p>{{'khoang_cach_giua_anh_va_ten_san_pham' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="1000" [nzStep]="1"
                                [ngModel]="config['search_result_name']['padding_left'] | vhnumber"
                                (ngModelChange)="config['search_result_name']['padding_left'] = $event + 'px'"
                                (nzOnAfterChange)="updateConfig()"
                            ></nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [nzMax]="1000" [nzStep]="1"
                        [ngModel]="config['search_result_name']['padding_left'] | vhnumber"
                        (ngModelChange)="config['search_result_name']['padding_left'] = $event + 'px'"
                        (nzOnAfterChange)="updateConfig()"></nz-slider>
                <!-- <div class="config-font">
                    <p class="title">Canh lề</p>
                    <div class="font">
                      <button class="font-text-btn" nz-button
                      [nzType]="class['search-result__name']['text-align'] == 'left' ? 'primary' : 'default'"
                              (click)="class['search-result__name']['text-align'] = 'left';
                                     updateClass()">
                        <i nz-icon nzType="align-left" nzTheme="outline"></i>
                      </button>
                      <button class="font-text-btn" nz-button
                              [nzType]="class['search-result__name']['text-align'] == 'center' ? 'primary' : 'default'"
                             (click)="class['search-result__name']['text-align'] = 'center';
                                      updateClass()">
                        <i nz-icon nzType="align-center" nzTheme="outline"></i>
                      </button>
                      <button class="font-text-btn" nz-button
                              [nzType]="class['search-result__name']['text-align'] == 'right' ? 'primary' : 'default'"
                              (click)="class['search-result__name']['text-align'] = 'right';
                                       updateClass()">
                        <i nz-icon nzType="align-right" nzTheme="outline"></i>
                      </button>
                      <button class="font-text-btn" nz-button
                            [nzType]="class['search-result__name']['text-align'] == 'justify' ? 'primary' : 'default'"
                            (click)="class['search-result__name']['text-align'] = 'justify';
                                    updateClass()">
                        <i class="bi bi-justify"></i>
                      </button>
                    </div>
                </div> -->
                
                <ng-container *ngIf="!config['format_search_result']['hide_image_enabled']">
                    <div >
                        <div class="config-name">
                            <p class="title">{{'kich_thuoc_anh' | translate}}</p>
                            <nz-input-number [nzMin]="30" [nzMax]="80" [nzStep]="1"
                                [ngModel]="class['search-result__image']['width'] | vhnumber"
                                (ngModelChange)="class['search-result__image']['width'] = $event + 'px';
                                                 class['search-result__image']['height'] = $event + 'px'"
                                (nzOnAfterChange)="updateClass()"
                            ></nz-input-number>
                        </div>
                        <nz-slider [nzMin]="30" [nzMax]="80" [nzStep]="1"
                        [ngModel]="class['search-result__image']['width'] | vhnumber"
                        (ngModelChange)="class['search-result__image']['width'] = $event + 'px';
                                         class['search-result__image']['height'] = $event + 'px'"
                        (nzOnAfterChange)="updateClass()"></nz-slider>
                    </div>
                </ng-container>
                <ul nz-menu nzMode="inline">
                    <!-- Tùy chỉnh viền kết quả -->
                    <li nz-submenu nzTitle="{{'tuy_chinh_kieu_ket_qua' | translate}}">
                        <div class="main-config">
                            <app-borders-config [device]="device"
                                                [elementChoosing]="objectChoosing"
                                                [class]="class"
                                                [borderClass]="class['search-result']"
                                                [id_object]="objectChoosing._id"
                                                >
                            </app-borders-config>
                            <!-- Nút mở rộng -->
                            <div class="config-name view-more-btn">
                                <p (click)="openViewAll(stylefields[5])">{{'mo_rong' | translate}} &#8594;</p>
                            </div>
                        </div>
                        
                    </li>
                    <!-- Tùy chỉnh viền item kết quả -->
                    <li nz-submenu nzTitle="{{'tuy_chinh_kieu_vien_item_ket_qua' | translate}}">
                        <div class="main-config">
                            <app-borders-config [device]="device"
                                                [elementChoosing]="objectChoosing"
                                                [class]="class"
                                                [borderClass]="class['search-result__item--border']"
                                                [id_object]="objectChoosing._id"
                                                >
                            </app-borders-config>
                            <!-- Nút mở rộng -->
                            <div class="config-name view-more-btn">
                                <p (click)="openViewAll(stylefields[2])">{{'mo_rong' | translate}} &#8594;</p>
                            </div>
                        </div>
                        
                    </li>
                    <!-- Bật đổ bóng -->
                    <li nz-submenu nzTitle="{{'do_bong_vien_ket_qua' | translate}}">
                        <app-shadow-config 
                                [device]="device"
                                [config]="config"
                                [class]="class"
                                [shadowClass]="class['search-result']"
                                [shadowConfig]="config['search_result_shadow']"
                                [objectChoosing]="objectChoosing"
                                >
                        </app-shadow-config>
                    </li>
                    <!-- Cấu hình object-fit -->
                    <li nz-submenu nzTitle="{{'do_bao_phu' | translate}} ">
                        <app-object-fit-config
                                [device]="device"
                                [class]="class"
                                [objectFitClass]="class['search-result__image']"
                                [style_field]="stylefields[4]"
                                (isViewAll)="openViewAll($event)"
                                [objectChoosing]="objectChoosing">
                        </app-object-fit-config>
                    </li>
                </ul>
            </div>
            
        </li>

        <ng-container *ngIf="objectChoosing.component == 'AtwSearch'">
            <li 
                nz-submenu nzTitle="{{'chon_nganh_hang' | translate}}" 
                [(nzOpen)]="openMap.menu7" 
                (nzOpenChange)="openHandler('menu7')" >
                <mat-form-field appearance="fill" >
                    <mat-label>{{'chon_nganh_hang' | translate}}</mat-label>
                    <mat-select [(ngModel)]="staticdata.main_sector" (ngModelChange)="updateStaticData()">
                    <mat-option *ngFor="let main_sector of main_sectors"  [value]="main_sector.value">{{main_sector.label}}</mat-option>
                    </mat-select>
                </mat-form-field>

            </li>

            <li 
                nz-submenu nzTitle="{{'cach_tim_kiem' | translate}}" 
                [(nzOpen)]="openMap.menu8" 
                (nzOpenChange)="openHandler('menu8')" >
                <mat-radio-group class="custom-radio" [(ngModel)]="staticdata.type_search" (ngModelChange)="updateStaticData()">
                    <mat-radio-button value="ai_search" matTooltipClass="custom-tooltip" matTooltip="{{'su_dung_tri_tue_nhan_tao_de_tim_kiem_chinh_xac_hon_xu_ly_cac_tu_gan_dung_va_cung_cap_goi_y_thong_minh' | translate}}">
                    {{'tim_kiem_ai' | translate}}
                    </mat-radio-button>
                    <mat-radio-button value="regular_search" matTooltipClass="custom-tooltip" matTooltip="{{'tim_kiem_co_ban_hien_thi_ket_qua_chinh_xac_theo_tu_khoa_ban_nhap_vao' | translate}}">
                    {{'tim_kiem_tu_khoa' | translate}}
                    </mat-radio-button>
                </mat-radio-group>

            </li>
            <!-- Kết nối trang tìm kiếm -->
            <li nz-submenu nzTitle="{{'ket_noi_trang_tim_kiem' | translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
                <div class="config-name" style="flex-direction: column;">
                    <p>{{'chon_trang_khi_nhan_vao_san_pham' | translate}}</p>
                    <nz-select [(ngModel)]="staticdata.page_link" 
                            (ngModelChange)="updateObject()"
                            nzPlaceHolder="{{'chon_lien_ket' | translate}}" allowClear
                            [disabled]="false">
                            <nz-option [nzValue]="null" [nzLabel]="'khong' | translate"></nz-option>
                            <nz-option *ngFor="let page of arr_link_page" [nzValue]="page.link || ''" [nzLabel]="page['name_' + functionService.selectedLanguageCode]"></nz-option>
                    </nz-select>
                    <!-- <label class="title">Chọn trang tìm kiếm</label>
                    <nz-select nzShowSearch nzAllowClear [(ngModel)]="staticdata['page_link']" 
                                (ngModelChange)="updateObject()">
                        <nz-option *ngFor="let options of arr_link_page" 
                                    nzCustomContent [nzLabel]="options.name" 
                                    [nzValue]="options.link">
                            {{options.name}}
                        </nz-option>
                    </nz-select> -->
                </div>
                <div class="config-name" style="flex-direction: column;">
                    <p>{{'chon_trang_lien_ket_khi_nhan_enter_hoac_nut' | translate}}</p>
                    <nz-select [(ngModel)]="staticdata.page_link_enter"
                            (ngModelChange)="updateObject()"
                            nzPlaceHolder="{{'chon_lien_ket' | translate}}" allowClear
                            [disabled]="false">
                            <nz-option [nzValue]="null" [nzLabel]="'khong' | translate"></nz-option>
                            <nz-option *ngFor="let page of arr_link_page" [nzValue]="page.link || ''" [nzLabel]="page['name_' + functionService.selectedLanguageCode]"></nz-option>
                    </nz-select>
                    <!-- <label class="title">Chọn trang tìm kiếm</label>
                    <nz-select nzShowSearch nzAllowClear [(ngModel)]="staticdata['page_link']" 
                                (ngModelChange)="updateObject()">
                        <nz-option *ngFor="let options of arr_link_page" 
                                    nzCustomContent [nzLabel]="options.name" 
                                    [nzValue]="options.link">
                            {{options.name}}
                        </nz-option>
                    </nz-select> -->
                </div>
                <!-- <div class="switch-image twins mb-2">
                    <label class="title">Từ khóa</label>
                    <input nz-input type="text" 
                            [(ngModel)]="staticdata['field_search']" 
                            [disabled]="false" 
                            (ngModelChange)="updateObject()" />
                </div> -->
            </li>
            <li nz-submenu nzTitle="{{'nhap_nhay_doi_mau_chu_goi_y' | translate}}" [(nzOpen)]="openMap.menu11" (nzOpenChange)="openHandler('menu11')">
                <div class="d-flex justify-content-between align-items-center">
                    <nz-switch [ngModel]="config.placeholder_change_color_auto?.enable"
                        (ngModelChange)="config.placeholder_change_color_auto.enable = $event; updateConfig()">
                    </nz-switch>
                </div>
                <ng-container *ngIf="config.placeholder_change_color_auto?.enable">
                    <div class="d-flex justify-content-between align-items-center mt-2">
                        <span style="line-height: 1.4;">{{ 'thoi_gian_chuyen' | translate }}</span>
                        <nz-input-number [nzMin]="0" [nzMax]="10" [nzStep]="0.1"
                            [ngModel]="config.placeholder_change_color_auto?.duration / 1000"
                            (ngModelChange)="config.placeholder_change_color_auto.duration = $event * 1000; updateConfig()">
                        </nz-input-number>
                    </div>
                    <div class="d-flex flex-column mt-2">
                        <span style="line-height: 1.4;">{{ 'danh_sach_mau_doi' | translate }}</span>
                        <div cdkDropList (cdkDropListDropped)="handleListColorPositionDrop($event)">
                            <ng-container *ngFor="let item of config.placeholder_change_color_auto?.color_list; let i = index; trackBy: trackColorListByIndex">
                                <div cdkDrag class="d-flex flex-row drag-item">
                                    <nz-input-group [nzPrefix]="dragHandle" [nzSuffix]="suffixTemplate">
                                    <div class="w-100" style="height: 22px; border-radius: 4px;"
                                        [style.background]="config.placeholder_change_color_auto.color_list[i]"
                                        (click)="colorSelectedIndex = i">
                                    </div>
                                    </nz-input-group>
                    
                                    <ng-template #dragHandle>
                                        <i cdkDragHandle class="bi bi-grip-vertical"
                                        style="cursor: grab; color: #999; margin-right: 4px;"></i>
                                    </ng-template>
                                
                                    <ng-template #suffixTemplate>
                                    <span nz-icon nzType="close-circle" (click)="handleRemoveColor(i)" 
                                        style="cursor: pointer; color: #ff4d4f;">
                                    </span>
                                    </ng-template>
                    
                                    <div class="drag-placeholder" *cdkDragPlaceholder></div>
                                </div>
                            </ng-container>
                        </div>
                        <div class="mt-2">
                            <button class="w-100 btn btn-primary py-1" (click)="handleAddColor()">
                              {{ 'them_mau' | translate }}
                            </button>
                            <ul nz-menu nzMode="inline" class="bg-transparent mt-2">
                              <li nz-submenu nzTitle="{{'chinh_mau'| translate}}" nz-tooltip
                              [nzTooltipTitle]="'chon_mau_trong_danh_sach_mau_phia_tren_sau_do_chinh_mau_o_muc_nay' | translate">
                                <span 
                                  class="mb-2" [cpWidth]="'192px'"
                                  [style.background]="config.placeholder_change_color_auto.color_list[colorSelectedIndex ?? 0]"
                                  [cpToggle]="true"
                                  [cpDialogDisplay]="'inline'"
                                  [cpUseRootViewContainer]="true"
                                  [(colorPicker)]="config.placeholder_change_color_auto.color_list[colorSelectedIndex ?? 0]"
                                  (colorPickerClose)="updateConfig()"
                                  [cpMaxPresetColorsLength]="functionService.cpMaxPresetColorsLength"
                                  [cpAddColorButton]="true"
                                  [cpAddColorButtonText]="'them_mau' | translate"
                                  [cpPresetLabel]="'bang_mau_mau' | translate"
                                  [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                                  [cpPresetColors]="functionService.themeColors"
                                  (cpPresetColorsChange)="functionService.presetColorsChange($event)"
                                ></span>
                                <button class="w-100 btn btn-primary pt-1" (click)="updateConfig()">
                                  {{ 'luu_tat_ca_cac_mau_vua_chinh' | translate }}
                                </button>
                              </li>
                            </ul>
                        </div>
                    </div>
                </ng-container>
            </li>
        </ng-container>

        <!-- SỰ KIỆN KHI TÌM KIẾM -->
        <li nz-submenu [nzTitle]="'su_kien_khi_tim_kiem' | translate" [(nzOpen)]="openMap.menu9" (nzOpenChange)="openHandler('menu9')">
            <div class="config-name">
                <p class="title">{{'dong_tat_ca_khoi_hop_thoai_dang_mo' | translate}}</p>
                <nz-switch 
                    [(ngModel)]="config['is_close_all_modal_on_search']"
                    (ngModelChange)="updateConfig()"></nz-switch>
            </div>
        </li>
        <!-- Hiển thị -->
        <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu10" (nzOpenChange)="openHandler('menu10')">
            <div class="main-config">
                
                <!-- Lựa chọn hiển thị cho các thiết bị -->
                <app-hide-show-config
                    [device]="device"
                    [elementChoosing]="objectChoosing">
                </app-hide-show-config>
            </div>
        </li>
  </ul>
</div>

<div class="editor-content" *ngIf="isViewAll">
    <div
      class="return"
      (click)="isViewAll = !isViewAll"
      style="
        display: flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;
        margin-bottom: 5px;
      "
    >
        <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
        <span (click)="isViewAll = !isViewAll" 
              style="font-weight: 500;">
            {{currentViewAll.title | translate}}</span>
    </div>
</div>

<div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền của ô tìm kiếm -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
        <app-borders-radius-config
                    [elementChoosing]="objectChoosing"
                    [device]="device"
                    [class]="class"
                    [borderRadiusClass]="class['search-box__input']"
                    [id_object]="objectChoosing._id"
        >
        </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết viền của button-->
    <div class="editor-field-body p-1" *ngIf="currentViewAll.index == 2">
        <app-borders-radius-config
                    [elementChoosing]="objectChoosing"
                    [device]="device"
                    [class]="class"
                    [borderRadiusClass]="class['search-box__button']"
                    [id_object]="objectChoosing._id"
        >
        </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết viền của item result -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 3">
        <app-borders-radius-config
                    [elementChoosing]="objectChoosing"
                    [device]="device"
                    [class]="class"
                    [borderRadiusClass]="class['search-result__item--border']"
                    [id_object]="objectChoosing._id"
        >
        </app-borders-radius-config>
    </div>
    <!-- Cấu hình chi tiết màu gradient của ô tìm kiếm -->
    <div class="container-gradient" *ngIf="currentViewAll.index == 4">
        <div class="title-head">
          <p class="text-fill">{{'phoi_mau' | translate}}</p>
          <label nz-checkbox [(ngModel)]="config['background-color-input']['gradient_check']"
            (ngModelChange)="updateBackgroundRgb('input')"></label>
        </div>
        <div class="list-gradient">
          <button class="btn-gradient" 
          *ngFor="
                let bgGradient of config['background-color-input']['gradient_arr'];
                let i = index
              " (click)="deleteGradient(i, 'input')" [ngStyle]="{ 'background-color': bgGradient }"
            [disabled]="!config['background-color-input']['gradient_check']">
            <i class="delete-icon bi bi-x-circle"></i>
          </button>
        </div>
        <p class="title-head">{{'them_mau' | translate}}</p>
        <div class="container_add-gradient">
          <input class="input-color" 
          [ngStyle]="{ 'cursor': config['background-color-input']['gradient_check'] ? 'pointer': 'not-allowed'}"
            [cpOKButton]="true" [(colorPicker)]="class['search-box__input']['background-color']" type="button"
            [disabled]="!config['background-color-input']['gradient_check']"
            [style.background]="class['search-box__input']['background-color']" (colorPickerClose)="addGradient($event, 'input')" />
        </div>
        <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
        <button class="gradient-direction" 
            *ngFor="let type of functionService.gradientDirectionList" nz-tooltip nzTooltipTitle="{{type.name | translate}}"
            (click)="chooseOption(type, $event, 'input')" [disabled]="!config['background-color-input']['gradient_check']" [style.background]="
              'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'"></button>
    </div>
    <!-- Cấu hình chi tiết màu gradient của nút tìm kiếm -->
    <div class="container-gradient" *ngIf="currentViewAll.index == 7">
        <div class="title-head">
          <p class="text-fill">{{'phoi_mau' | translate}}</p>
          <label nz-checkbox [(ngModel)]="config['background-color-button']['gradient_check']"
            (ngModelChange)="updateBackgroundRgb('button')"></label>
        </div>
        <div class="list-gradient">
          <button class="btn-gradient" 
          *ngFor="
                let bgGradient of config['background-color-button']['gradient_arr'];
                let i = index
              " (click)="deleteGradient(i, 'button')" [ngStyle]="{ 'background-color': bgGradient }"
            [disabled]="!config['background-color-button']['gradient_check']">
            <i class="delete-icon bi bi-x-circle"></i>
          </button>
        </div>
        <p class="title-head">{{'them_mau' | translate}}</p>
        <div class="container_add-gradient">
          <input class="input-color" 
          [ngStyle]="{ 'cursor': config['background-color-button']['gradient_check'] ? 'pointer': 'not-allowed'}"
            [cpOKButton]="true" [(colorPicker)]="class['search-box__button']['background-color']" type="button"
            [disabled]="!config['background-color-button']['gradient_check']"
            [style.background]="class['search-box__button']['background-color']" (colorPickerClose)="addGradient($event, 'button')" />
        </div>
        <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
        <button class="gradient-direction" 
            *ngFor="let type of functionService.gradientDirectionList" nz-tooltip nzTooltipTitle="{{type.name | translate}}"
            (click)="chooseOption(type, $event, 'button')" [disabled]="!config['background-color-button']['gradient_check']" [style.background]="
              'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'"></button>
    </div>
    <!-- Mở rộng cấu hình độ bao phủ -->
    <div class="editor-field-body p-1" *ngIf="currentViewAll.index == 5">
        <div class="field-row">
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <p class="m-0" style="font-weight: 500; font-size: 14px">
              {{'vi_tri_hinh_anh' | translate}}
            </p>
          </div>
        </div>
        <div class="field-row">
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <p class="m-0">{{'ngang' | translate}}</p>
            <nz-input-number
              [(ngModel)]="config['object_fit_image']['object_x']"
              [nzMin]="0"
              [nzStep]="1"
              (ngModelChange)="handleSetPositionImage()"
              style="width: 40%"
            ></nz-input-number>
          </div>
          <nz-slider
            [(ngModel)]="config['object_fit_image']['object_x']"
            (ngModelChange)="handleSetPositionImage()"
          ></nz-slider>
        </div>
        <div class="field-row">
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <p class="m-0">{{'doc' | translate}}</p>
            <nz-input-number
              [nzStep]="1"
              [(ngModel)]="config['object_fit_image']['object_y']"
              (ngModelChange)="handleSetPositionImage()"
              style="width: 40%"
            ></nz-input-number>
          </div>
          <nz-slider
            [(ngModel)]="config['object_fit_image']['object_y']"
            (ngModelChange)="handleSetPositionImage()"
          ></nz-slider>
        </div>
        <div class="field-row">
            <div
                style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                "
            >
                <p class="m-0" style="font-weight: 500; font-size: 14px">
                {{'phong_thu_hinh_anh' | translate}}
                </p>
            </div>
        </div>
    </div>
     <!-- Cấu hình chi tiết viền của result -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 6">
        <app-borders-radius-config
            [elementChoosing]="objectChoosing"
            [device]="device"
            [class]="class"
            [borderRadiusClass]="class['search-result']"
            [id_object]="objectChoosing._id"
        >
        </app-borders-radius-config>
    </div>

    <!-- Cấu hình viền của thanh tìm kiếm -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 8">
        <app-borders-radius-config
            [elementChoosing]="objectChoosing"
            [device]="device"
            [class]="class"
            [borderRadiusClass]="class['search-box']"
            [id_object]="objectChoosing._id"
        >
        </app-borders-radius-config>
    </div>
</div>
